import { Avatar, Space, Table } from 'antd';
import React from 'react';
import dayjs from 'dayjs';

import { TableFilter } from 'shared/ui/TableFilter';

import { MembersFilters, MembersProps } from '../service/members.interface';

type Props = {
    readonly source: MembersProps[];
    readonly filters: MembersFilters;
    readonly onFiltersUpdate: (update: Partial<MembersFilters>) => void;
    readonly loading: boolean;
};

export const MembersTable = ({
    source,
    onFiltersUpdate,
    filters,
    loading,
}: Props) => {
    return (
        <Table
            loading={loading}
            dataSource={source}
            rowKey={user => user.nick_name}
            pagination={{
                total: source?.length,
                showTotal: () => `Участников: ${source?.length}`,
            }}
        >
            <Table.Column
                title={
                    <TableFilter<string>
                        title='Имя'
                        onChange={first_name => {
                            onFiltersUpdate({ first_name });
                        }}
                        value={filters.first_name}
                    >
                        <TableFilter.Text />
                    </TableFilter>
                }
                render={member => (
                    <Space>
                        {member.image && <Avatar src={member.image} />}
                        {!member.image && (
                            <Avatar>{member.name.charAt(0)}</Avatar>
                        )}
                        <span>{member.name}</span>
                    </Space>
                )}
            />
            <Table.Column
                title={
                    <TableFilter<string>
                        title='Юзренейм'
                        onChange={nick_name => {
                            onFiltersUpdate({ nick_name });
                        }}
                        value={filters.nick_name}
                    >
                        <TableFilter.Text />
                    </TableFilter>
                }
                dataIndex={'nick_name'}
                render={name => name ?? `@${name}`}
            />
            <Table.Column
                title='Дата и время вступления'
                defaultSortOrder='descend'
                sortDirections={['ascend', 'descend']}
                sorter={(a: MembersProps, b: MembersProps) =>
                    a.accession_date - b.accession_date
                }
                render={user =>
                    dayjs.unix(user.accession_date).format('DD.MM.YY, HH:mm')
                }
            />
        </Table>
    );
};
